import React from 'react';
import img from '../assets/images/logo.png';

const Logo = () => {
  return (
    <div className="Page-Header">
      <div className="Page-Header__LogoWrapper">
        <img className="Page-Header__Logo" alt="Rig by AGR Software" src={img} />
      </div>
    </div>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js